<template>
  <div :style="isNoShadow ? 'width: 100%;' : 'width: 100%; box-shadow: 0px 12px 44px 0px #0000001F;'">
    <v-alert
      outlined
      :color="color"
      text
      class="mb-0 font-weight-regular py-2 text-center px-2"
    >
      <div class="font-bold bg-white py-2 rounded" style="font-size: 18px; position: relative;">{{ title }}</div>
      <div class="mx-2 mt-5 mb-2" style="font-size: 18px;">{{ totalValue | currencySuffixTextThEn }}</div>

      <slot name="content"></slot>
    </v-alert>
  </div>
</template>
<script>
export default {
  props: {
    color: String,
    totalValue: Number,
    title: String,
    isNoShadow: Boolean
  }
}
</script>